const MAX_CALL_STACK_PATTERN = /Maximum call stack size exceeded/

// rrweb/Session Replay stylesheet-observer internals; these names survive
// minification, so they identify the recursion below even in a production build.
const REPLAY_FRAME_PATTERN = /\b(?:styleSheetRuleCb|waitForCheckout)\b/


// Sentry's own Session Replay (rrweb) is bundled into our first-party origin, so
// when its stylesheet-observer instrumentation recurses into a stack overflow — a
// known rrweb defect where the Proxy it installs on `CSSStyleSheet.prototype`
// ends up wrapping itself — the error carries our origin and slips past the frame
// check. We recognize Replay's own frames in the overflowing stack and drop it; a
// genuine first-party recursion won't name them.
//
// This takes the exception values rather than a flattened frame list because the
// message and the frames have to come from the same exception. Flattened, one
// exception's overflow message would match another exception's Replay frames.
//
export default function isReplayRecursion(values) {
  return values.some(({ stacktrace, value }) =>
    MAX_CALL_STACK_PATTERN.test(value || '')
      && (stacktrace?.frames || []).some(({ function: frameFn }) => REPLAY_FRAME_PATTERN.test(frameFn || '')),
  )
}
